import GlassBottle from "../images/wine-bottle.svg";
import AppleCore from "../images/apple-core.svg";
import CardboardBox from "../images/cardboard-box.svg";
import CoffeeCup from "../images/coffee-cup.svg";
import DrinkCan from "../images/drinks-can.svg";
import MilkCarton from "../images/milk-carton.svg";
import Newspaper from "../images/newspaper.svg";
import Papers from "../images/paper.svg";
import PlasticBag from "../images/plastic-bag.svg";
import PlasticBottle from "../images/plastic-bottle.svg";
import Shirt from "../images/shirt.svg";
import SweetWrapper from "../images/sweet-wrapper.svg";
import TeaBag from "../images/tea-bag.svg";
import TreeLeaves from "../images/leaves.svg";
import Grass from "../images/grass-and-yard-clippings.svg";
import Cellphone from "../images/cellphone.svg";
import MotorOil from "../images/motor-oil.svg";
import Furniture from "../images/furniture.svg";
import DVDCDTape from "../images/dvd-cd-vcr-tape.svg";
import PensMarkers from "../images/pens_and_markers.svg";
import AlkalineBattery from "../images/alkaline-batteries.svg";
import PlasticDetergentBottle from "../images/plastic-detergent-bottles.svg";
import PlasticUtensils from "../images/plastic-utensils.svg";
import IceCreamContainers from "../images/ice-cream-containers.svg";
import TinCan from "../images/tin-can.svg";
import Straw from "../images/straw.png";
import Can from "../images/can.png";
import Apple from "../images/apple.png";
import MilkGallon from "../images/milk_bottle.png";
import NewsPaper from "../images/newspaper.png";
import WaterBottle from "../images/water_bottle.png";
import PopsicleStick from "../images/popsicle_stick.png";
import PizzaBox from "../images/pizza_box.png";
import GreasyPizzaBox from "../images/greasy_pizza_box.png";
import ToiletRoll from "../images/toilet_roll.png";
import PlasticBagNew from "../images/plastic-bag.png";
import Envelope from "../images/letter.png";
import Ketchup from "../images/ketchup.png";
import IceCreamTubCardboard from "../images/iceCreamTubCardboard.png";
import IceCreamTubPlastic from "../images/iceCreamTubPlastic.png";
import GlassBottleNew from "../images/glass-bottle.png";
import Chips from "../images/chips.png";
import CoffeeCupNew from "../images/coffeeCup.png";
import CoffeeCupOnlyCup from "../images/coffeeCupOnlyCup.png";
import CoffeeCupOnlyLid from "../images/coffeeCupOnlyLid.png";

const items = [
  {
    id: "glassBottles", 
    name: "Glass Bottles",
    src: GlassBottle,
    bin: "recycling",
    fact: "Families use around 330 glass bottles and jars every year"
  },
  {
    id: "coffeeCups", 
    name: "Coffee Cups",
    src: CoffeeCup,
    bin: "general waste",
    fact: "You can sometimes take coffee cups back to the shop for recycling!"
  },
  {
    id: "newspapers",
    name: "Newspapers",
    src: Newspaper,
    bin: "recycling",
    fact: "It takes one tree to make 230 newspapers or magazines!"
  },
  {
    id: "teaBags",
    name: "Tea Bags",
    src: TeaBag,
    bin: "food compost",
    fact: "Tea bags can be turned into compost for your plants!"
  },
  {
    id: "appleCores",
    name: "Apple Cores",
    src: AppleCore,
    bin: "food compost",
    fact: "Uneaten food items can be used to make food for animals!"
  },
  {
    id: "cardboardBoxes",
    name: "Cardboard Boxes",
    src: CardboardBox,
    bin: "recycling",
    fact: "Flatten cardboard boxes before they go in the bin!"
  },
  {
    id: "drinkCans",
    name: "Drink Cans",
    src: DrinkCan,
    bin: "recycling",
    fact:
      "A recycled drinks can could be back in the shops as a new drink within 60 days!"
  },
  {
    id: "milkCartons",
    name: "Milk Cartons",
    src: MilkCarton,
    bin: "recycling",
    fact:
      "Drinks cartons can usually be recyled, but not always...see if you can find the rules for your area!"
  },
  {
    id: "papers",
    name: "Papers",
    src: Papers,
    bin: "recycling",
    fact: "Uncontaminated paper always goes into the recycling bin."
  },
  {
    id: "plasticBags",
    name: "Plastic Bags",
    src: PlasticBag,
    bin: "general waste",
    fact: "If you get a reusable bag you won't need so many plastic ones!"
  },
  {
    id: "plasticBottles",
    name: "Plastic Bottles",
    src: PlasticBottle,
    bin: "recycling",
    fact: "It can take 500 years for plastic to fully decompose!"
  },
  {
    id: "clothes",
    name: "Clothes",
    src: Shirt,
    bin: "special programs",
    fact: "You can donate old clothes to charity shops or clothing recycling bins!"
  },
  {
    id: "sweetWrappers",
    name: "Sweet Wrappers",
    src: SweetWrapper,
    bin: "general waste",
    fact:
      "Every year, we throw away enough plastic to circle the world 5 times!"
  },
  {
    id: "tinCans",
    name: "Tin Cans",
    src: TinCan,
    bin: "recycling",
    fact: "Canned food can last for two years!"
  },
  {
    id: "straw",
    name: "Straw",
    src: Straw,
    bin: "general waste",
    fact: "Straws are made out of plastic, but they are too small for recycling facilities."
  },
  {
    id: "aluminiumCans",
    name: "Aluminium Cans",
    src: Can,
    bin: "recycling",
    fact: "Aluminium cans are 100% recyclable."
  },
  {
    id: "apple",
    name: "Apple",
    src: Apple,
    bin: "food compost",
    fact: "Food waste cannot be recycled. To reduce your food waste, build a compost bin!"
  },
  {
    id: "milkGallon",
    name: "Milk Gallon",
    src: MilkGallon,
    bin: "recycling",
    fact: "If your milk gallon is made out of plastic, put it in the recycling bin."
  },
  {
    id: "newspaper",
    name: "Newspaper",
    src: NewsPaper,
    bin: "recycling",
    fact: "Uncontaminated paper always goes into the recycling bin."
  },
  {
    id: "waterBottle",
    name: "Water Bottle",
    src: WaterBottle,
    bin: "recycling",
    fact: "If your water bottle is made out of plastic, always put it in the recycling bin."
  },
  {
    id: "popsicleStick",
    name: "Popsicle Stick",
    src: PopsicleStick,
    bin: "general waste",
    fact: "Popsicle sticks are already made out of recycled materials, so it can’t be recycled again!"
  },
  {
    id: "pizzaBox",
    name: "Pizza Box",
    src: PizzaBox,
    bin: "recycling",
    fact: "Pizza boxes are 100% recyclable if they’re not contaminated."
  },
  {
    id: "greasyPizzaBox",
    name: "Greasy Pizza Box",
    src: GreasyPizzaBox,
    bin: "general waste",
    fact: "Greasy and contaminated items cannot go into the recycling bin!"
  },
  {
    id: "toiletRoll",
    name: "Toilet Roll",
    src: ToiletRoll,
    bin: "recycling",
    fact: "Toilet rolls are made out of cardboard which is 100% recyclable!"
  },
  {
    id: "plasticBagNew",
    name: "Plastic Bag",
    src: PlasticBagNew,
    bin: "general waste",
    fact: "Plastic bags cannot go in curbside recycling bins, but you can drop them off at designated soft plastic recycling bins located near the entrance of local grocery stores like Walmart and Giant!"
  },
  {
    id: "envelope",
    name: "Envelope",
    src: Envelope,
    bin: "general waste",
    fact: "If your envelope still has the thin plastic film over it, it cannot be placed in the recycling bin."
  },
  {
    id: "ketchup",
    name: "Ketchup",
    src: Ketchup,
    bin: "general waste",
    fact: "Ketchup sachets are made out of multiple layers of different materials which cannot be separated for recycling."
  },
  {
    id: "iceCreamTubCardboard",
    name: "Ice Cream Tub Cardboard",
    src: IceCreamTubCardboard,
    bin: "general waste",
    fact: "Cardboard ice-cream containers are contaminated and cannot be recycled."
  },
  {
    id: "iceCreamTubPlastic",
    name: "Ice Cream Tub Plastic",
    src: IceCreamTubPlastic,
    bin: "recycling",
    fact: "Plastic ice-cream containers can be recycled, but make sure to rinse them before you put it into the recycling bin!"
  },
  {
    id: "glassBottleNew",
    name: "Glass Bottle",
    src: GlassBottleNew,
    bin: "recycling",
    fact: "Glass bottles are 100% recyclable."
  },
  {
    id: "chips",
    name: "Chips",
    src: Chips,
    bin: "general waste",
    fact: "Snack packaging and chip bags are made of multi-layer materials (plastic and foil) that cannot be recycled in the U.S. and must go in the trash."
  },
  {
    id: "coffeeCupNew",
    name: "Coffee Cup",
    src: CoffeeCupNew,
    bin: "general waste",
    fact: "Takeaway coffee cups cannot be put into the recycling bin as it is! Some parts are recyclable whilst other parts are not!"
  },
  {
    id: "coffeeCupOnlyCup",
    name: "Coffee Cup Only",
    src: CoffeeCupOnlyCup,
    bin: "general waste",
    fact: "The cups of coffee cups usually have a layer of wax in it which is not recyclable!"
  },
  {
    id: "coffeeCupOnlyLid",
    name: "Coffee Cup Led Only",
    src: CoffeeCupOnlyLid,
    bin: "recycling",
    fact: "The lids of takeaway coffee cups are recyclable alone."
  },
  {
    id: "treeLeaves",
    name: "Tree Leaves",
    src: TreeLeaves,
    bin: "yard waste",
    fact: "Leaves can be composted and turned into nutrient-rich soil!"
  },
  {
    id: "grassClippings",
    name: "Grass Clippings",
    src: Grass,
    bin: "yard waste",
    fact: "Grass clippings can be composted and used as mulch!"
  }, 
  {
    id: "cellphone",
    name: "Cellphone",
    src: Cellphone,
    bin: "special programs",
    fact: "Old cellphones can be recycled at special e-waste recycling points!"
  }, 
  {
    id: "motorOils",
    name: "Motor Oils",
    src: MotorOil,
    bin: "special programs",
    fact: "Used motor oils can be recycled at special collection points!"
  },
  {
    id: "furniture",
    name: "Furniture",
    src: Furniture,
    bin: "special programs",
    fact: "Old furniture can be recycled or donated to local charities!"
  },
  {
    id: "dvdCdVcrTape",
    name: "DVD/CD/VCR Tape",
    src: DVDCDTape,
    bin: "general waste",
    fact: "Old DVDs, CDs and VCR tapes cannot be recycled in regular recycling bins."
  }, 
  {
    id: "pensAndMarkers",
    name: "Pens and Markers",
    src: PensMarkers,
    bin: "general waste",
    fact: "Used pens and markers go in the general waste bin as they cannot be recycled."
  }, 
  {
    id: "alkalineBatteries",
    name: "Alkaline Batteries",
    src: AlkalineBattery,
    bin: "general waste",
    fact: "Alkaline batteries can be disposed of in the general waste bin, but consider using rechargeable batteries to reduce waste!"  
  }, 
  {
    id: "plasticDetergentBottles",
    name: "Plastic Detergent Bottles",
    src: PlasticDetergentBottle,
    bin: "recycling",
    fact: "Plastic detergent bottles are 100% recyclable. Remember to rinse them out before recycling!"
  }, 
  {
    id: "plasticUtensils",
    name: "Plastic Utensils",
    src: PlasticUtensils,
    bin: "general waste",
    fact: "Plastic utensils cannot be recycled in regular recycling bins."
  }, 
  {
    id: "iceCreamContainers",
    name: "Ice Cream Containers",
    src: IceCreamContainers,
    bin: "general waste",
    fact: "Ice cream containers are often contaminated and cannot be recycled."
  }

];

export default items;
